export const translations = {
  en: {
    nav: { catalogue: "Catalogue", shop: "Shop", contact: "Contact", inquire: "Inquiries", about: "About Us" },
    about: {
      eyebrow: "Our story",
      title: "About Us",
      paragraphs: [
        "BuyHeda is an independent luxury consignment store specializing in new luxury goods. With more than 10 years of experience in the luxury resale industry, we have built our business on carefully selected pieces from leading international fashion and jewelry houses.",
        "Long before the launch of BuyHeda.com, our business grew through social media. For more than 10 years, we have introduced our clients to carefully curated pieces from some of the world’s most renowned luxury brands. Our Instagram, Telegram, and other social media platforms have grown alongside us and today represent a long-standing digital history of our work, collections, and relationships with our clients.",
        "Links to our social media platforms are available in the Contact section of our website. There, you can explore collections from different years featuring exclusive, authentic, and vintage pieces from renowned fashion and jewelry houses. We also have a dedicated group featuring customer reviews and experiences.",
        "BuyHeda specializes in the consignment sale of new luxury goods. Our core selection consists of pieces that have never been used or worn and are in new condition.",
        "Our collection may also include rare and vintage pieces from past collections. The term “vintage” primarily refers to the age and collection of an item and does not necessarily mean that it has been previously used. We offer new pieces from past seasons and rare models that may no longer be available through the brands’ current collections.",
        "Authenticity and quality are at the heart of everything we do. Every item is carefully selected before being offered on our website.",
        "We believe that purchasing luxury should not necessarily mean overpaying. With more than a decade of experience, established sourcing channels, and a specialization in the consignment sale of new luxury goods, we strive to offer our clients some of the most attractive prices on the market.",
      ],
      closing: "Welcome to BuyHeda.",
      contactCta: "Contact us",
    },
    hero: {
      eyebrow: "Maison Heda Gelogaeva",
      line1: "Objects of",
      line2: "quiet",
      line3: "obsession",
      sub: "Rare designer pieces and fine jewellery, curated for the woman who chooses presence over noise.",
      cta1: "View Catalogue",
      cta2: "Enter the Shop",
      scroll: "Scroll",
    },
    home: {
      title: "The Maison Edit",
      intro: "Designer wardrobe and fine jewellery, curated for you.",
      searchPlaceholder: "Search pieces, brands…",
      search: "Search",
      browse: "Shop by category",
      tiles: { clothing: "Clothes", bags: "Bags", shoes: "Shoes", jewellery: "Jewellery" },
      trust: { worldwide: "Worldwide delivery", shippingIncluded: "Shipping included", couriers: "Private couriers" },
    },
    marquee: "New Arrivals — Fine Jewellery — Designer Bags — Heda Gelogaeva — Exclusive Selection —",
    manifesto: {
      title: "The Maison",
      chapters: [
        { n: "01", h: "Curation, not collection", p: "Every piece is chosen by hand. We favour the exceptional over the abundant — objects that hold their value and their allure." },
        { n: "02", h: "Diamonds & white gold", p: "Full parures in white gold set with brilliant-cut diamonds, topaz and emeralds. Certified, complete, and made to be worn." },
        { n: "03", h: "Personal service", p: "No checkout, no rush. Reserve a piece and we will attend to you personally over WhatsApp, from selection to delivery." },
      ],
    },
    catalogue: {
      title: "Catalogue",
      sub: "A visual edit of our finest pieces this season.",
    },
    shop: {
      title: "The Shop",
      sub: "Reserve your selection. We confirm every order personally.",
      filters: { all: "All", clothing: "Clothes", bags: "Bags", shoes: "Shoes", jewellery: "Jewellery" },
      add: "Add to selection",
      added: "Added",
      empty: "Nothing selected yet",
      loadError: "Couldn't load products, please try again",
      retry: "Retry",
      soldOut: "Sold out",
      lowStock: "Low stock",
      selectSize: "Select size",
      chooseSize: "Please choose a size",
      available: "available",
      shippingIncluded: "Worldwide shipping included",
      shippingIncludedFull: "Shipping included · no extra charges",
      priceMatch: {
        badge: "Price Match Guarantee",
        text: "Found it for less? We'll match any authentic retailer's price to ensure you get the best deal on BuyHeda.",
      },
      sizeGuide: "Size guide",
      sizeGuideTitle: "Ring size conversion",
      sizeGuideNote: "RU = inner diameter (mm); EU = inner circumference (mm). UK & US are approximate.",
      shoeSizeGuideTitle: "Shoe size conversion",
      shoeSizeGuideNote: "EU is our primary size. UK & US are approximate — if you're between sizes, we suggest sizing up.",
      clothingSizeGuideTitle: "Clothing size conversion",
      clothingSizeGuideNote: "International sizes with EU, UK & US equivalents. Fit can vary by designer — refer to any item-specific notes.",
    },
    cart: {
      title: "Your Selection",
      emptyTitle: "Your selection is empty",
      emptySub: "Add pieces you love and send them to us in one message.",
      total: "Estimated total",
      send: "Send via WhatsApp",
      remove: "Remove",
      size: "Size",
      note: "Prices are indicative. Final quote confirmed on WhatsApp.",
      msgIntro: "Hello Heda, I would like to reserve the following pieces:",
    },
    wishlist: {
      title: "Favourites",
      emptyTitle: "No favourites yet",
      emptySub: "Tap the heart on any piece to save it here and revisit it later.",
      move: "Move to selection",
      remove: "Remove",
      note: "Saved on this device. Move pieces to your selection to inquire.",
    },
    footer: {
      tagline: "Designer clothing & fine jewellery.",
      explore: "Explore",
      contactTitle: "Contact",
      whatsapp: "WhatsApp",
      email: "Email",
      rights: "All rights reserved.",
    },
    inquiry: {
      open: "Contact",
      title: "Write to us",
      subtitle: "Send an inquiry straight to our inbox — we reply personally.",
      name: "Your name",
      email: "Your email",
      phone: "Phone (optional)",
      message: "Message",
      messagePlaceholder: "Tell us which pieces you're interested in…",
      include: "Attach my selection",
      send: "Send inquiry",
      sending: "Sending…",
      via: "Send via Email",
      success: "Thank you — your inquiry has been sent. We'll be in touch shortly.",
      error: "Something went wrong. Please try again, or reach us on WhatsApp.",
    },
    payment: {
      open: "Checkout",
      title: "Checkout",
      subtitle: "Pay securely by card. Charged in US Dollars.",
      summary: "Order summary",
      total: "Total",
      qty: "Qty",
      taxNote: "Tax is calculated at checkout.",
      empty: "Your selection is empty.",
      payButton: "Pay by card",
      payPaypal: "Pay with PayPal",
      processingBtn: "Redirecting…",
      secure: "Secure payment powered by Stripe.",
      backToShop: "Back to shop",
      processing: "Confirming your payment…",
      successTitle: "Payment received",
      successMsg: "Thank you — your order is confirmed. We'll be in touch shortly.",
      orderNumber: "Your order number",
      failedTitle: "Payment not completed",
      failedMsg: "Your payment could not be confirmed. Please try again.",
      cancelTitle: "Checkout cancelled",
      cancelMsg: "No payment was taken. Your selection is still saved.",
      continue: "Continue",
      thankYouTitle: "Thank you",
      thankYouLead: "Thank you for choosing BuyHeda. Your order",
      thankYouTrail: "is being prepared with care.",
      continueShopping: "Continue Shopping",
      accountStep: "1 · Your account",
      shippingStep: "2 · Shipping address",
      signedInAs: "Signed in as",
      authToggle: "Sign in or create an account",
      authToggleHint: "— save your details & track orders",
      guestNote: "Or simply continue as a guest below.",
      emailConfirmNote: "We'll send your order confirmation here.",
      guardComplete: "Complete your shipping details above to continue.",
      guardAddress: "Please complete your shipping address.",
      guardEmail: "Please enter a valid email so we can send your confirmation.",
      fields: {
        full_name: "Full name", full_namePh: "Jane Doe",
        email: "Email", emailPh: "you@email.com",
        line1: "Address line 1", line1Ph: "Street and number",
        line2: "Address line 2", line2Ph: "Apartment, suite (optional)",
        city: "City", cityPh: "City",
        state: "State / Province", statePh: "State or province",
        postal_code: "Postal code", postal_codePh: "ZIP / Postal code",
        country: "Country", countryPh: "Country",
        phone: "Phone", phonePh: "For delivery updates",
        courier_note: "Message to courier", courier_notePh: "Delivery instructions (optional) — e.g. leave with concierge, buzzer code…",
      },
    },
    auth: {
      signIn: "Sign in",
      createAccount: "Create account",
      name: "Name", namePh: "Your name",
      email: "Email", emailPh: "you@email.com",
      password: "Password", passwordPh: "••••••••",
      google: "Continue with Google",
      or: "or",
      welcomeBack: "Welcome back",
      created: "Account created",
      error: "Something went wrong",
    },
    account: {
      heading: "Account",
      headingIn: "My account",
      tagline: "Sign in to save your favourites, follow your orders and check out faster next time.",
      signedInAs: "Signed in as",
      signOut: "Sign out",
      favourites: "My favourites",
      continueShopping: "Continue shopping",
      orderHistory: "Order history",
      noOrders: "No orders yet.",
      contactTitle: "Contact information",
      name: "Name", namePh: "Your name",
      phone: "Phone", phonePh: "Phone number",
      email: "Email",
      emailLocked: "Your email is your sign-in and cannot be changed here.",
      save: "Save",
      contactSaved: "Contact details updated",
      contactError: "Could not save your details",
      shippingTitle: "Shipping details",
      shippingHint: "Saved for faster checkout — we'll pre-fill this next time.",
      addrSaved: "Shipping details saved",
      addrError: "Could not save your address",
      addrIncomplete: "Please complete the required address fields.",
      passwordTitle: "Change password",
      setPasswordTitle: "Set a password",
      googleHint: "You signed in with Google. Set a password to also sign in with your email.",
      currentPassword: "Current password",
      newPassword: "New password", newPasswordPh: "At least 6 characters",
      confirmPassword: "Confirm new password", confirmPasswordPh: "Repeat new password",
      changeBtn: "Change password", setBtn: "Set password",
      pwChanged: "Password changed", pwSet: "Password set",
      pwShort: "New password must be at least 6 characters.",
      pwMismatch: "Passwords do not match.",
      pwError: "Could not change your password",
      privacyTitle: "Privacy & data",
      privacyText: "You can download a copy of the personal data we hold about you, or permanently delete your account. See our",
      privacyPolicy: "Privacy Policy",
      download: "Download my data",
      delete: "Delete my account",
      dataDownloaded: "Your data has been downloaded",
      dataError: "Could not export your data",
      deleteConfirm: "Delete your account permanently? Your profile and saved favourites will be removed. This cannot be undone.",
      deleted: "Your account has been deleted",
      deleteError: "Could not delete your account",
    },
    cookie: {
      text: "We use only essential cookies to keep you signed in and remember your selection. We do not use advertising trackers. See our",
      policy: "Cookie Policy",
      accept: "Accept",
    },
    currencyLabel: "Currency",
    langLabel: "Language",
    from: "from",
    seo: {
      home: { title: "Authentic Luxury Fashion, Bags & Fine Jewelry", description: "Shop authentic luxury fashion, designer bags, shoes, watches and fine jewelry at BuyHeda. Carefully curated pieces with worldwide delivery and shipping included." },
      catalogue: { title: "Authentic Luxury Designer Fashion & Jewelry", description: "Browse the full BuyHeda collection of authentic luxury designer fashion, bags, shoes and fine jewelry — carefully curated, with worldwide delivery and shipping included." },
      categories: {
        clothing: { title: "Authentic Designer Clothing & Luxury Fashion", description: "Shop authentic designer clothing and luxury fashion at BuyHeda — a curated selection of pieces from leading houses, with worldwide delivery and shipping included." },
        bags: { title: "Authentic Designer Bags & Luxury Handbags", description: "Explore authentic designer bags and luxury handbags at BuyHeda — carefully curated pieces from leading fashion houses, with worldwide delivery and shipping included." },
        shoes: { title: "Authentic Designer Shoes & Luxury Heels", description: "Discover authentic designer shoes and luxury heels at BuyHeda — carefully selected styles from renowned brands, with worldwide delivery and shipping included." },
        jewellery: { title: "Authentic Fine Jewelry, Watches & Designer Jewelry", description: "Browse authentic fine jewelry, watches and designer jewelry at BuyHeda — curated pieces with worldwide delivery and shipping included." },
      },
      product: { lead: "Shop the authentic", tail: "at BuyHeda.", shipping: "Worldwide delivery with shipping included." },
      contact: { title: "Contact & Inquiries", description: "Reach Heda Gelogaeva for personal styling, private reservations and inquiries via WhatsApp, Instagram or email." },
      about: { title: "About Us — BuyHeda", description: "BuyHeda is an independent luxury consignment store specializing in new luxury goods, with more than 10 years of experience in the luxury resale industry — authentic pieces from leading fashion and jewelry houses." },
      account: { title: "My Account", description: "Manage your Heda Gelogaeva account, wishlist, saved delivery details and order history." },
      checkout: { title: "Secure Checkout", description: "Complete your Heda Gelogaeva order with secure card or PayPal payment and worldwide delivery." },
      success: { title: "Order Confirmed", description: "Thank you — your Heda Gelogaeva order has been confirmed." },
      cancel: { title: "Payment Cancelled", description: "Your Heda Gelogaeva payment was cancelled. Your selection has been saved." },
    },
  },
  ru: {
    nav: { catalogue: "Каталог", shop: "Магазин", contact: "Контакты", inquire: "Заявки", about: "О нас" },
    about: {
      eyebrow: "Наша история",
      title: "О нас",
      paragraphs: [
        "BuyHeda — независимый комиссионный магазин новых предметов роскоши. За нашей работой стоит более 10 лет опыта в сфере перепродажи товаров класса люкс.",
        "Задолго до появления BuyHeda.com наш бизнес развивался через социальные сети. Уже более 10 лет мы знакомим наших клиентов с тщательно отобранными изделиями ведущих мировых брендов. Наши страницы в Instagram, Telegram и других социальных сетях развивались вместе с нами и сегодня представляют собой многолетнюю цифровую историю нашей работы, коллекций и отношений с клиентами.",
        "Ссылки на наши социальные сети доступны в разделе «Контакты» на сайте. Там вы можете познакомиться с коллекциями разных лет, включающими эксклюзивные, оригинальные и винтажные изделия известных мировых домов моды и ювелирных брендов. У нас также есть отдельная группа с отзывами, где представлены впечатления и опыт наших клиентов.",
        "BuyHeda специализируется на продаже новых товаров класса люкс на комиссионной основе. Основу нашего ассортимента составляют изделия, которые не использовались, не носились и находятся в новом состоянии.",
        "В нашем ассортименте также могут встречаться редкие и винтажные изделия прошлых коллекций. При этом понятие «винтаж» относится прежде всего к возрасту и коллекции изделия и не означает, что оно было в употреблении. Мы предлагаем новые изделия прошлых лет и редкие модели, которые могут быть недоступны в современных коллекциях брендов.",
        "Подлинность и качество являются основополагающими принципами нашей работы. Каждое изделие проходит тщательный отбор перед размещением на сайте.",
        "Мы считаем, что приобретение предметов роскоши не должно означать необходимость переплачивать. Благодаря более чем 10-летнему опыту, налаженным каналам приобретения и специализации на комиссионной продаже новых товаров мы стремимся предлагать нашим клиентам одни из наиболее привлекательных цен на рынке.",
      ],
      closing: "Добро пожаловать в BuyHeda.",
      contactCta: "Связаться с нами",
    },
    hero: {
      eyebrow: "Дом Heda Gelogaeva",
      line1: "Предметы",
      line2: "тихой",
      line3: "страсти",
      sub: "Редкие дизайнерские вещи и ювелирные изделия — для женщины, которая выбирает присутствие, а не шум.",
      cta1: "Смотреть каталог",
      cta2: "Перейти в магазин",
      scroll: "Листайте",
    },
    home: {
      title: "Коллекция Дома",
      intro: "Дизайнерский гардероб и ювелирные изделия — отобранные для вас.",
      searchPlaceholder: "Поиск вещей, брендов…",
      search: "Найти",
      browse: "Категории",
      tiles: { clothing: "Одежда", bags: "Сумки", shoes: "Обувь", jewellery: "Украшения" },
      trust: { worldwide: "Доставка по всему миру", shippingIncluded: "Доставка включена", couriers: "Частные курьеры" },
    },
    marquee: "Новые поступления — Ювелирные изделия — Дизайнерские сумки — Heda Gelogaeva — Эксклюзивный выбор —",
    manifesto: {
      title: "О Доме",
      chapters: [
        { n: "01", h: "Кураторство, не коллекция", p: "Каждая вещь отобрана вручную. Мы предпочитаем исключительное изобильному — предметы, что сохраняют ценность и очарование." },
        { n: "02", h: "Бриллианты и белое золото", p: "Полные комплекты из белого золота с бриллиантами огранки, топазом и изумрудами. Сертифицированы, комплектны и созданы, чтобы их носили." },
        { n: "03", h: "Личный сервис", p: "Без спешки и корзины. Забронируйте вещь — и мы лично проведём вас в WhatsApp, от выбора до доставки." },
      ],
    },
    catalogue: {
      title: "Каталог",
      sub: "Визуальная подборка наших лучших вещей сезона.",
    },
    shop: {
      title: "Магазин",
      sub: "Забронируйте выбор. Каждый заказ мы подтверждаем лично.",
      filters: { all: "Всё", clothing: "Одежда", bags: "Сумки", shoes: "Обувь", jewellery: "Украшения" },
      add: "Добавить к выбору",
      added: "Добавлено",
      empty: "Пока ничего не выбрано",
      loadError: "Не удалось загрузить товары, попробуйте ещё раз",
      retry: "Повторить",
      soldOut: "Продано",
      lowStock: "Мало в наличии",
      selectSize: "Выберите размер",
      chooseSize: "Пожалуйста, выберите размер",
      available: "в наличии",
      shippingIncluded: "Доставка по всему миру включена",
      shippingIncludedFull: "Доставка включена · без доплат",
      priceMatch: {
        badge: "Гарантия лучшей цены",
        text: "Нашли дешевле? Мы подберём цену любого официального ритейлера, чтобы вы получили лучшее предложение в BuyHeda.",
      },
      sizeGuide: "Таблица размеров",
      sizeGuideTitle: "Соответствие размеров колец",
      sizeGuideNote: "RU = внутренний диаметр (мм); EU = внутренняя окружность (мм). UK и US приблизительны.",
      shoeSizeGuideTitle: "Соответствие размеров обуви",
      shoeSizeGuideNote: "EU — наш основной размер. UK и US приблизительны — если вы между размерами, рекомендуем выбрать больший.",
      clothingSizeGuideTitle: "Соответствие размеров одежды",
      clothingSizeGuideNote: "Международные размеры с эквивалентами EU, UK и US. Посадка может отличаться у разных дизайнеров — смотрите примечания к конкретной вещи.",
    },
    cart: {
      title: "Ваш выбор",
      emptyTitle: "Ваш выбор пуст",
      emptySub: "Добавьте понравившиеся вещи и отправьте их нам одним сообщением.",
      total: "Примерная сумма",
      send: "Отправить в WhatsApp",
      remove: "Удалить",
      size: "Размер",
      note: "Цены ориентировочные. Финальную стоимость подтвердим в WhatsApp.",
      msgIntro: "Здравствуйте, Heda! Хочу забронировать следующие вещи:",
    },
    wishlist: {
      title: "Избранное",
      emptyTitle: "Пока нет избранного",
      emptySub: "Нажмите на сердечко у любой вещи, чтобы сохранить её здесь и вернуться позже.",
      move: "Перенести в выбор",
      remove: "Удалить",
      note: "Сохранено на этом устройстве. Перенесите вещи в выбор, чтобы оформить заявку.",
    },
    footer: {
      tagline: "Дизайнерская одежда и ювелирные изделия.",
      explore: "Разделы",
      contactTitle: "Контакты",
      whatsapp: "WhatsApp",
      email: "Email",
      rights: "Все права защищены.",
    },
    inquiry: {
      open: "Контакты",
      title: "Напишите нам",
      subtitle: "Отправьте заявку прямо нам на почту — мы отвечаем лично.",
      name: "Ваше имя",
      email: "Ваш email",
      phone: "Телефон (необязательно)",
      message: "Сообщение",
      messagePlaceholder: "Напишите, какие вещи вас интересуют…",
      include: "Приложить мой выбор",
      send: "Отправить заявку",
      sending: "Отправляем…",
      via: "Отправить на почту",
      success: "Спасибо — ваша заявка отправлена. Мы скоро свяжемся с вами.",
      error: "Что-то пошло не так. Попробуйте ещё раз или напишите в WhatsApp.",
    },
    payment: {
      open: "Оплата",
      title: "Оплата",
      subtitle: "Оплатите картой безопасно. Списание в долларах США.",
      summary: "Ваш заказ",
      total: "Итого",
      qty: "Кол-во",
      taxNote: "Налог рассчитывается при оплате.",
      empty: "Ваш выбор пуст.",
      payButton: "Оплатить картой",
      payPaypal: "Оплатить через PayPal",
      processingBtn: "Переадресация…",
      secure: "Безопасная оплата через Stripe.",
      backToShop: "Вернуться в магазин",
      processing: "Подтверждаем оплату…",
      successTitle: "Оплата получена",
      successMsg: "Спасибо — ваш заказ подтверждён. Мы скоро свяжемся с вами.",
      orderNumber: "Номер вашего заказа",
      failedTitle: "Оплата не завершена",
      failedMsg: "Не удалось подтвердить оплату. Попробуйте ещё раз.",
      cancelTitle: "Оплата отменена",
      cancelMsg: "Списание не произведено. Ваш выбор сохранён.",
      continue: "Продолжить",
      thankYouTitle: "Спасибо",
      thankYouLead: "Спасибо, что выбрали BuyHeda. Ваш заказ",
      thankYouTrail: "готовится с заботой.",
      continueShopping: "Продолжить покупки",
      accountStep: "1 · Ваш аккаунт",
      shippingStep: "2 · Адрес доставки",
      signedInAs: "Вы вошли как",
      authToggle: "Войти или создать аккаунт",
      authToggleHint: "— сохраните данные и отслеживайте заказы",
      guestNote: "Или просто продолжите как гость ниже.",
      emailConfirmNote: "Мы отправим подтверждение заказа сюда.",
      guardComplete: "Заполните данные доставки выше, чтобы продолжить.",
      guardAddress: "Пожалуйста, заполните адрес доставки.",
      guardEmail: "Укажите корректный email, чтобы мы отправили подтверждение.",
      fields: {
        full_name: "Имя и фамилия", full_namePh: "Иван Иванов",
        email: "Email", emailPh: "you@email.com",
        line1: "Адрес, строка 1", line1Ph: "Улица и дом",
        line2: "Адрес, строка 2", line2Ph: "Квартира, офис (необязательно)",
        city: "Город", cityPh: "Город",
        state: "Область / регион", statePh: "Область или регион",
        postal_code: "Почтовый индекс", postal_codePh: "Индекс",
        country: "Страна", countryPh: "Страна",
        phone: "Телефон", phonePh: "Для уведомлений о доставке",
        courier_note: "Сообщение курьеру", courier_notePh: "Инструкции для доставки (необязательно) — напр. оставить у консьержа, код домофона…",
      },
    },
    auth: {
      signIn: "Войти",
      createAccount: "Создать аккаунт",
      name: "Имя", namePh: "Ваше имя",
      email: "Email", emailPh: "you@email.com",
      password: "Пароль", passwordPh: "••••••••",
      google: "Продолжить через Google",
      or: "или",
      welcomeBack: "С возвращением",
      created: "Аккаунт создан",
      error: "Что-то пошло не так",
    },
    account: {
      heading: "Аккаунт",
      headingIn: "Мой аккаунт",
      tagline: "Войдите, чтобы сохранять избранное, отслеживать заказы и оформлять покупки быстрее.",
      signedInAs: "Вы вошли как",
      signOut: "Выйти",
      favourites: "Избранное",
      continueShopping: "Продолжить покупки",
      orderHistory: "История заказов",
      noOrders: "Заказов пока нет.",
      contactTitle: "Контактная информация",
      name: "Имя", namePh: "Ваше имя",
      phone: "Телефон", phonePh: "Номер телефона",
      email: "Email",
      emailLocked: "Ваш email используется для входа и не может быть изменён здесь.",
      save: "Сохранить",
      contactSaved: "Контактные данные обновлены",
      contactError: "Не удалось сохранить данные",
      shippingTitle: "Данные доставки",
      shippingHint: "Сохраняем для быстрого оформления — заполним автоматически в следующий раз.",
      addrSaved: "Данные доставки сохранены",
      addrError: "Не удалось сохранить адрес",
      addrIncomplete: "Пожалуйста, заполните обязательные поля адреса.",
      passwordTitle: "Сменить пароль",
      setPasswordTitle: "Установить пароль",
      googleHint: "Вы вошли через Google. Установите пароль, чтобы также входить по email.",
      currentPassword: "Текущий пароль",
      newPassword: "Новый пароль", newPasswordPh: "Не менее 6 символов",
      confirmPassword: "Подтвердите новый пароль", confirmPasswordPh: "Повторите новый пароль",
      changeBtn: "Сменить пароль", setBtn: "Установить пароль",
      pwChanged: "Пароль изменён", pwSet: "Пароль установлен",
      pwShort: "Новый пароль должен содержать не менее 6 символов.",
      pwMismatch: "Пароли не совпадают.",
      pwError: "Не удалось изменить пароль",
      privacyTitle: "Конфиденциальность и данные",
      privacyText: "Вы можете скачать копию своих персональных данных или удалить аккаунт навсегда. См. нашу",
      privacyPolicy: "Политику конфиденциальности",
      download: "Скачать мои данные",
      delete: "Удалить аккаунт",
      dataDownloaded: "Ваши данные скачаны",
      dataError: "Не удалось выгрузить данные",
      deleteConfirm: "Удалить аккаунт навсегда? Ваш профиль и сохранённое избранное будут удалены. Это действие необратимо.",
      deleted: "Ваш аккаунт удалён",
      deleteError: "Не удалось удалить аккаунт",
    },
    cookie: {
      text: "Мы используем только необходимые файлы cookie, чтобы вы оставались в системе и мы помнили ваш выбор. Мы не используем рекламные трекеры. См. нашу",
      policy: "Политику cookie",
      accept: "Принять",
    },
    currencyLabel: "Валюта",
    langLabel: "Язык",
    from: "от",
    seo: {
      home: { title: "Оригинальная люксовая мода, сумки и ювелирные изделия", description: "Оригинальная люксовая мода, дизайнерские сумки, обувь, часы и ювелирные изделия в BuyHeda. Тщательно отобранные вещи с доставкой по всему миру — отправка включена." },
      catalogue: { title: "Оригинальная люксовая дизайнерская мода и украшения", description: "Полная коллекция BuyHeda: оригинальная люксовая дизайнерская мода, сумки, обувь и ювелирные изделия — тщательно отобранные, доставка по всему миру, отправка включена." },
      categories: {
        clothing: { title: "Оригинальная дизайнерская одежда и люксовая мода", description: "Оригинальная дизайнерская одежда и люксовая мода в BuyHeda — тщательно отобранная коллекция изделий ведущих домов, доставка по всему миру, отправка включена." },
        bags: { title: "Оригинальные дизайнерские и люксовые сумки", description: "Оригинальные дизайнерские и люксовые сумки в BuyHeda — тщательно отобранные изделия ведущих домов моды, доставка по всему миру, отправка включена." },
        shoes: { title: "Оригинальная дизайнерская обувь и люксовые туфли", description: "Оригинальная дизайнерская обувь и люксовые туфли в BuyHeda — тщательно подобранные модели известных брендов, доставка по всему миру, отправка включена." },
        jewellery: { title: "Оригинальные ювелирные изделия, часы и украшения", description: "Оригинальные ювелирные изделия, часы и дизайнерские украшения в BuyHeda — тщательно отобранные изделия, доставка по всему миру, отправка включена." },
      },
      product: { lead: "Купите оригинальный", tail: "в BuyHeda.", shipping: "Доставка по всему миру — отправка включена." },
      contact: { title: "Контакты и заявки", description: "Свяжитесь с Heda Gelogaeva для персонального подбора, резервирования и заявок через WhatsApp, Instagram или email." },
      about: { title: "О нас — BuyHeda", description: "BuyHeda — независимый комиссионный магазин новых предметов роскоши с более чем 10-летним опытом в сфере перепродажи товаров класса люкс — подлинные изделия ведущих домов моды и ювелирных брендов." },
      account: { title: "Мой аккаунт", description: "Управляйте аккаунтом Heda Gelogaeva: избранное, данные доставки и история заказов." },
      checkout: { title: "Безопасное оформление", description: "Завершите заказ Heda Gelogaeva с безопасной оплатой картой или PayPal и доставкой по всему миру." },
      success: { title: "Заказ подтверждён", description: "Спасибо — ваш заказ Heda Gelogaeva подтверждён." },
      cancel: { title: "Оплата отменена", description: "Оплата Heda Gelogaeva была отменена. Ваш выбор сохранён." },
    },
  },
};

export const CURRENCIES = {
  USD: { symbol: "$", rate: 1 / 90, position: "before", locale: "en-US" },
  EUR: { symbol: "€", rate: 1 / 100, position: "before", locale: "de-DE" },
};

export const formatPrice = (priceRub, currency) => {
  const c = CURRENCIES[currency] || CURRENCIES.USD;
  const decimals = 2;
  const raw = priceRub * c.rate;
  const value = Math.round(raw * 100) / 100;
  const formatted = new Intl.NumberFormat(c.locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(value);
  return c.position === "before" ? `${c.symbol}${formatted}` : `${formatted} ${c.symbol}`;
};
